import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { CmsReducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { CmsEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('cms', CmsReducer),
    EffectsModule.forFeature([CmsEffects])
  ]
})
export class CmsStoreModule { }
